import { HECTARE_TO_ACRE, PeriodEnum } from 'common/defines/clients';
import { IYieldSummary } from 'interfaces/erms';
import { FC } from 'react';
import ComparisonItem from '../../../components/ComparisonItem';

interface YieldComparisonSectionProps {
  yieldData: IYieldSummary[];
  hoverDatePoint: string;
  selectedPeriod: PeriodEnum;
  area: number;
  totalTree: number;
}

const YieldComparisonSection: FC<YieldComparisonSectionProps> = ({
  yieldData,
  hoverDatePoint,
  selectedPeriod,
  area,
  totalTree,
}) => {
  const totalYieldWeight = yieldData.reduce((acc, cur) => {
    return acc + cur.totalWeighbridgeNetWeight;
  }, 0);
  const selectedDateData = yieldData.find((item) => item._id === hoverDatePoint);

  const totalHarvest = yieldData.reduce((acc, cur) => {
    return acc + cur.totalHarvest;
  }, 0);

  const comparedYieldWeight = selectedDateData?.totalWeighbridgeNetWeight || 0;
  const averageYieldWeight = totalYieldWeight / yieldData.length;

  const comparedYieldWeightPerHarvest = totalHarvest ? comparedYieldWeight / totalHarvest : 0;
  const averageYieldWeightPerHarvest = totalHarvest ? averageYieldWeight / totalHarvest : 0;

  const comparedYieldWeightPerTree = totalTree ? comparedYieldWeight / totalTree : 0;
  const averageYieldWeightPerTree = totalTree ? averageYieldWeight / totalTree : 0;

  const comparedYieldWeightPerHectare = area ? comparedYieldWeight / area : 0;
  const averageYieldWeightPerHectare = area ? averageYieldWeight / area : 0;

  const comparedYieldWeightPerAcre = area ? comparedYieldWeight / area / HECTARE_TO_ACRE : 0;
  const averageYieldWeightPerAcre = area ? averageYieldWeight / area / HECTARE_TO_ACRE : 0;

  const listComparisonItems = [
    { label: 'Yield (Metric Tonne)', comparedValue: comparedYieldWeight, averageValue: averageYieldWeight },
    {
      label: 'Yield/Harvest (Metric Tonne/Harvest)',
      comparedValue: comparedYieldWeightPerHarvest,
      averageValue: averageYieldWeightPerHarvest,
    },
    {
      label: 'Yield/Tree (Metric Tonne/Tree)',
      comparedValue: comparedYieldWeightPerTree,
      averageValue: averageYieldWeightPerTree,
    },
    {
      label: 'Yield/Acre (Metric Tonne/Acre)',
      comparedValue: comparedYieldWeightPerAcre,
      averageValue: averageYieldWeightPerAcre,
    },
    {
      label: 'Yield/Hectare (Metric Tonne/Hectare)',
      comparedValue: comparedYieldWeightPerHectare,
      averageValue: averageYieldWeightPerHectare,
    },
  ];

  return (
    <>
      {listComparisonItems.map((item, index) => (
        <ComparisonItem
          key={index}
          label={item.label}
          comparedValue={item.comparedValue}
          averageValue={item.averageValue}
          selectedPeriod={selectedPeriod}
        />
      ))}
    </>
  );
};

export default YieldComparisonSection;
